@for(price of prices; track price.text) {
    @if(price.text === 'line') {
        <hr>
    } @else {
        <div [class]="price.text">
            <span>{{ 'summary.'+price.text | uppercase | translate }}</span>
            <span>{{ price.price | price: { showZeroValue:true } }}</span>
        </div>
    }
}
